// Provides proxy access to enums on the window,
// and acts as a quarantine zone for enum issues
// arising from discrepancies between js and py.
// FIXME Resolve discrepancies between js an py enums.
// TODO Get rid of this and pass enums directly.
// This requires all Py/JS enum discrepancies to be resolved.
import {t} from 'common/utils/translation-util';

export const enums = window && window.enums ? window.enums : {};

export const AnalyticAppBillingStatisticEnum = {
  ...enums.AnalyticAppBillingStatisticEnum,
};

export const AnalyticAppEnum = {
  ...enums.AnalyticAppEnum,
};

export const AnalyticAppDataSelectionEnum = {
  ...enums.AnalyticAppDataSelectionEnum,
};

export const AnalyticAppErrorMessageEnum = {
  ...enums.AnalyticAppErrorMessageEnum,
};

export const AnalyticAppInteractionEnum = {
  ...enums.AnalyticAppInteractionEnum,
};

export const AnalyticAppOutcomeEnum = {
  ...enums.AnalyticAppOutcomeEnum,
};

export const AnalyticAppRendererEnum = {
  ...enums.AnalyticAppRendererEnum,
};

export const BatteryStatusEnum = {
  ...enums.BatteryStatusEnum,
};

export const BuildingEnum = {
  ...enums.BuildingEnum,

  // FIXME
  // JS expects these types to be present,
  // but they don't exist on the Py side.
  // Unsure how to remove at this stage.
  ALL_FACILITIES: {
    id: null,
    displayName: t('All Buildings'),
    pluralize: t('All Buildings'),
    slug: 'all',
  },
  ALL_TENANTS: {
    id: null,
    displayName: t('All Tenants'),
    pluralize: t('All Tenants'),
    slug: 'alltenants',
  },
};

export const ReportCardHeightTypeEnum = {
  ...enums.ReportCardHeightTypeEnum,
};

export const ReportDetailsEnum = {
  ...enums.ReportDetailsEnum,
};

export const DateTimeFormat = {
  ...enums.DateTimeFormat,
};

export const ErrandStatusEnum = {
  ...enums.ErrandStatusEnum,
};

export const FloorPlanTypeEnum = {
  ...enums.FloorPlanTypeEnum,
};

export const MeterTypeEnum = {
  ...enums.MeterTypeEnum,

  // FIXME
  // JS needs a DEFAULT meter type that does not
  // exist in the Py enum. This is used by
  // chart-display-rules-enum.js to create
  // default display rules for rarer meter types
  // that don't have those rules explicitly defined.
  // This can be removed along with
  // chart-display-rules-enum.js itself once those
  // rules are dynamic and have been moved to the db.
  DEFAULT: {
    displayName: t('Unknown'),
    id: 999,
    slug: 'unknown',
  },

  // FIXME
  // JS needs there to be a meter type of TOTAL_ENERGY,
  // but it no longer exists on Py's MeterTypeEnum.
  // Instead this type exists on Py's MeterTypeGroupEnum.
  // So we add the type shadily to MeterTypeEnum here in JS.
  // Unsure at this juncture how to get rid of this.
  TOTAL_ENERGY: {
    displayName: t('Total Energy'),
    iconClass: 'cog',
    id: 31,
    slug: 'totalenergy',
  },
};

export const OrientationEnum = {
  ...enums.OrientationEnum,
};

export const ReportChartTypeEnum = {
  ...enums.ReportChartTypeEnum,
};

export const ReportingDaysEnum = {
  ...enums.ReportingDaysEnum,
};

export const ReportOrderEnum = {
  ...enums.ReportOrderEnum,
};

export const ReportingPeriodEnum = {
  ...enums.ReportingPeriodEnum,

  // FIXME Retrieve from back end
  // Front-end only
  LESS_THAN_FOURTY_EIGHT_HOURS: {
    displayName: 'Less than fourty-eight hours',
    slug: 'lessThan48Hours',
  },
  LESS_THAN_SEVEN_DAYS: {
    displayName: 'Less than seven days',
    slug: 'lessThan7Days',
  },
  LESS_THAN_THIRTY_DAYS: {
    displayName: 'Less than thirty days',
    slug: 'lessThan30Days',
  },
  LESS_THAN_NINETY_DAYS: {
    displayName: 'Less than ninety days',
    slug: 'lessThan90Days',
  },
  LESS_THAN_TWELVE_MONTHS: {
    displayName: 'Less than twelve months',
    slug: 'lessThan12Months',
  },
  MORE_THAN_TWELVE_MONTHS: {
    displayName: 'More than twelve months',
    slug: 'moreThan12Months',
  },
  NONE: {
    displayName: 'None',
    slug: 'none',
  },
};

export const ReportBuildingInfoDetailsEnum = {
  ...enums.ReportBuildingInfoDetailsEnum,
};

export const ReportComparisonEnum = {
  ...enums.ReportComparisonEnum,
};

export const ReportDifferenceColorEnum = {
  ...enums.ReportDifferenceColorEnum,
};

export const ReportDynamicGaugeDirectionEnum = {
  ...enums.ReportDynamicGaugeDirectionEnum,
};

export const ReportGoalTypeEnum = {
  ...enums.ReportGoalTypeEnum,
};

export const ReportZoneFlowNodeJustificationEnum = {
  ...enums.ReportZoneFlowNodeJustificationEnum,
};

export const ReportLayoutEnum = {
  ...enums.ReportLayoutEnum,
};

export const ReportLegendColorsEnum = {
  ...enums.ReportLegendColorsEnum,
};

export const ReportTableDensityEnum = {
  ...enums.ReportTableDensityEnum,
};

export const ReportTableKeyEnum = {
  ...enums.ReportTableKeyEnum,
};

export const ReportZoneFlowColorByEnum = {
  ...enums.ReportZoneFlowColorByEnum,
};

export const ReportZoneFlowOpacityEnum = {
  ...enums.ReportZoneFlowOpacityEnum,
};

export const ReportObjectSizeEnum = {
  ...enums.ReportObjectSizeEnum,
};

export const ReportTypesEnum = {
  ...enums.ReportTypesEnum,
};

export const PointScopeEnum = {
  ...enums.PointScopeEnum,
};

export const StartingTimescaleEnum = {
  ...enums.StartingTimescaleEnum,
};

export const StatisticsEnum = {
  ...enums.StatisticsEnum,
};

export const TimeResolutionEnum = {
  ...enums.TimeResolutionEnum,
};
